// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-validator-ui {
   width: fit-content;
}

.password-validator-ui .validation-container {
   padding: var(--padding);
   width: 300px;
   display: flex;
   flex-direction: row;
}

.password-validator-ui .validation-rules .valid {
   color: var(--success)
}

.password-validator-ui .validation-rules .invalid {
   color: var(--error);
   font-weight: bold;
}

.password-validator-ui img.validation-icon {
   filter: invert(32%) sepia(52%) saturate(4801%) hue-rotate(6deg) brightness(93%) contrast(98%);
}

.password-validator-ui span.last-rule {
   display: block;
}

.password-validator-ui .validation-icon {
   height: 15px;
   right: 0px;
   bottom: 0px;
   margin: unset;
   padding-left: var(--padding)
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLPassword/ECLPasswordValidatorUI/ECLPasswordValidatorUI.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;AACrB;;AAEA;GACG,uBAAuB;GACvB,YAAY;GACZ,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG;AACH;;AAEA;GACG,mBAAmB;GACnB,iBAAiB;AACpB;;AAEA;GACG,6FAA6F;AAChG;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,YAAY;GACZ,UAAU;GACV,WAAW;GACX,aAAa;GACb;AACH","sourcesContent":[".password-validator-ui {\r\n   width: fit-content;\r\n}\r\n\r\n.password-validator-ui .validation-container {\r\n   padding: var(--padding);\r\n   width: 300px;\r\n   display: flex;\r\n   flex-direction: row;\r\n}\r\n\r\n.password-validator-ui .validation-rules .valid {\r\n   color: var(--success)\r\n}\r\n\r\n.password-validator-ui .validation-rules .invalid {\r\n   color: var(--error);\r\n   font-weight: bold;\r\n}\r\n\r\n.password-validator-ui img.validation-icon {\r\n   filter: invert(32%) sepia(52%) saturate(4801%) hue-rotate(6deg) brightness(93%) contrast(98%);\r\n}\r\n\r\n.password-validator-ui span.last-rule {\r\n   display: block;\r\n}\r\n\r\n.password-validator-ui .validation-icon {\r\n   height: 15px;\r\n   right: 0px;\r\n   bottom: 0px;\r\n   margin: unset;\r\n   padding-left: var(--padding)\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
